import React, { useState } from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import submit from "submit-form";
import { round } from "lodash";
import convert from "convert-units";

const ClientGoals = (props) => {
  const { locals } = props;

  const clientGoals = locals?.clientGoals;
  const anyGoalCompleted = clientGoals.filter((goal) => !!goal.completed);

  return (
    <div className="goals-display">
      <div className="goals-section">
        <GoalSection
          clientGoals={clientGoals}
          title={"Personal Record Goals"}
          goalType={"personalRecord"}
          activeUser={locals?.activeUser}
          completed={false}
        />

        <GoalSection
          clientGoals={clientGoals}
          title={"Custom Goals"}
          goalType={"custom"}
          activeUser={locals?.activeUser}
          completed={false}
        />
      </div>
      {anyGoalCompleted.length > 0 && (
        <>
          <div className="separator"></div>
          <div className="goals-section">
            <GoalSection
              clientGoals={clientGoals}
              title={"Personal Records Achieved"}
              goalType={"personalRecord"}
              activeUser={locals?.activeUser}
              completed={true}
            />

            <GoalSection
              clientGoals={clientGoals}
              title={"Custom Goals Achieved"}
              goalType={"custom"}
              activeUser={locals?.activeUser}
              completed={true}
            />
          </div>
        </>
      )}
    </div>
  );
};

const GoalSection = ({
  clientGoals,
  title,
  goalType,
  completed,
  activeUser,
}) => {
  return (
    <article>
      {!completed ? <header>{title}</header> : <p>{title}</p>}
      <ul>
        {clientGoals &&
          clientGoals.length > 0 &&
          clientGoals.map((goal) => {
            if (
              goal.type === goalType &&
              Boolean(goal.completed) === completed
            ) {
              return (
                <GoalItem
                  goal={goal}
                  key={`${goal._id}`}
                  activeUser={activeUser}
                />
              );
            }
          })}
      </ul>
      {!completed && (
        <button
          data-button-type="outline"
          onClick={() => {
            submit("/actions/refresh?", {
              method: "GET",
              body: {
                "modal[type]": "add-client-goal",
                modalState: goalType,
              },
            });
          }}
        >
          Add
        </button>
      )}
    </article>
  );
};

const GoalItem = ({ goal, activeUser }) => {
  const [opened, setOpened] = useState(false);

  return (
    <li>
      <div>
        <DisplayGoalLabel goal={goal} activeUser={activeUser} />

        <div>
          <details role="list" open={opened}>
            <summary
              onClick={(e) => {
                e.preventDefault();
                setOpened(!opened);
              }}
              onBlur={(e) => {
                e.preventDefault();
                setOpened(false);
              }}
            >
              <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
            </summary>
            <ul role="listbox" className={opened ? "opened" : ""}>
              {!goal.completed && (
                <li
                  onMouseDown={() => {
                    submit("/actions/refresh?", {
                      method: "GET",
                      body: {
                        "modal[type]": "add-client-goal",
                        modalState: goal.type,
                        goalId: goal._id,
                      },
                    });
                  }}
                >
                  <a>Edit</a>
                </li>
              )}
              <li
                onMouseDown={() => {
                  submit(
                    `/actions/client-goals/complete-client-goal/${goal._id}`,
                    {
                      method: "POST",
                      body: {
                        completed: !goal.completed,
                        goals: [goal._id],
                      },
                    }
                  );
                }}
              >
                <a>Mark as {!!goal.completed ? "incomplete" : "complete"}</a>
              </li>
              <li
                onMouseDown={() => {
                  submit(
                    `/actions/client-goals/delete-client-goal/${goal._id}`,
                    {
                      method: "GET",
                    }
                  );
                }}
              >
                <a className="!text-[--danger]">Delete</a>
              </li>
            </ul>
          </details>
        </div>
      </div>
    </li>
  );
};

const DisplayGoalLabel = ({ goal, activeUser }) => {
  if (goal.type === "custom")
    return (
      <article className="goal-item">
        <div className="goal-item-with-icon">
          {!!goal.completed && <div className="chip success"></div>}
          <SvgIcon
            src={`/img/new-icons/${goal.details.customIcon}.svg`}
            classNames="goal-icon"
          />
          <p>{goal.details.customName}</p>
        </div>
        <p>{goal.details.customTarget}</p>
      </article>
    );

  if (goal.type === "personalRecord") {
    const unit = activeUser.units === "metric" ? "Kg" : "Lbs";

    return (
      <article className="goal-item">
        <div className="goal-item-with-icon">
          {!!goal.completed && <div className="chip success"></div>}
          <p>{goal.details.targetName}</p>
        </div>
        <p>
          {goal.details.targetReps} reps @{" "}
          {`${
            activeUser.units === "metric"
              ? round(goal.details.targetLoad || 0, 2)
              : round(
                  convert(goal.details.targetLoad || 0)
                    .from("kg")
                    .to("lb"),
                  2
                )
          } ${unit}`}
        </p>
      </article>
    );
  }

  return <></>;
};

export default ClientGoals;
